import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initSentry } from "@/lib/sentry";

initSentry();

const _origFetch = window.fetch.bind(window);
window.fetch = ((input: RequestInfo | URL, init?: RequestInit) =>
  _origFetch(input, { ...init, credentials: "include" })) as typeof window.fetch;

createRoot(document.getElementById("root")!).render(<App />);
